// import { enhancedDetector } from '@/utils/enhanced-detector';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { App, ConfigProvider, ConfigProviderProps, theme } from 'antd';
import PasswordExpiryChecker from '@/components/PasswordExpiryChecker';
import pt_BR from 'antd/lib/locale/pt_BR';
import deDE from 'antd/locale/de_DE';
import enUS from 'antd/locale/en_US';
import vi_VN from 'antd/locale/vi_VN';
import zhCN from 'antd/locale/zh_CN';
import zh_HK from 'antd/locale/zh_HK';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime'; // ES 2015
import weekOfYear from 'dayjs/plugin/weekOfYear';
import weekYear from 'dayjs/plugin/weekYear';
import weekday from 'dayjs/plugin/weekday';
import React, { ReactNode, useState } from 'react';
import { Provider, Provider as ReduxProvider } from 'react-redux';
import { ThemeProvider, useTheme } from './components/theme-provider';
import { TooltipProvider } from './components/ui/tooltip';
import { ThemeEnum } from './constants/common';
import { store } from './store/store';
// import i18n from '@/locales/config';
// // 生产环境启用    添加打开检查限制
// if (process.env.NODE_ENV === 'production') {
//   // 自动启用
//   console.log(
//     process.env.NODE_ENV,
//     '自动启用---process.env.NODE_ENV',
//     enhancedDetector,
//   );
// }
dayjs.extend(customParseFormat);
dayjs.extend(advancedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(weekOfYear);
dayjs.extend(weekYear);
dayjs.extend(relativeTime);
dayjs.locale('zh-cn');
const AntLanguageMap = {
  en: enUS,
  zh: zhCN,
  'zh-TRADITIONAL': zh_HK,
  vi: vi_VN,
  'pt-BR': pt_BR,
  de: deDE,
};

if (process.env.NODE_ENV === 'development') {
  const whyDidYouRender = require('@welldone-software/why-did-you-render');
  whyDidYouRender(React, {
    trackAllPureComponents: true,
    trackExtraHooks: [],
    logOnDifferentValues: true,
  });
}

const queryClient = new QueryClient();

type Locale = ConfigProviderProps['locale'];
// 添加REM响应式布局初始化逻辑
const initRemLayout = () => {
  console.log('initRemLayout');
  const setRootFontSize = () => {
    const clientWidth = document.documentElement.clientWidth;
    document.documentElement.style.fontSize = clientWidth / 10 + 'px';
  };
  window.addEventListener('resize', setRootFontSize);
  setRootFontSize();
};

// 在渲染应用前调用初始化
// initRemLayout();
function Root({ children }: React.PropsWithChildren) {
  const { theme: themeragflow } = useTheme();
  // const getLocale = (lng: string) =>
  //   AntLanguageMap[lng as keyof typeof AntLanguageMap] ?? enUS;

  const [locale, setLocal] = useState<Locale>(zhCN);

  // i18n.on('languageChanged', function (lng: string) {
  //   storage.setLanguage(lng);
  //   setLocal(getLocale(lng));
  // });

  return (
    <>
      <ConfigProvider
        theme={{
          token: {
            fontFamily: 'Inter',
          },
          components: {
            Button: {
              textHoverBg: 'rgba(86,119,227,0.2);',
            },
          },
          algorithm:
            themeragflow === 'dark'
              ? theme.darkAlgorithm
              : theme.defaultAlgorithm,
        }}
        locale={locale}
      >
        <Provider store={store}>
          <App className="h-full overflow-auto">
            <PasswordExpiryChecker />
            {children}
          </App>
        </Provider>
      </ConfigProvider>
      <ReactQueryDevtools buttonPosition={'bottom-right'} />
    </>
  );
}

const RootProvider = ({ children }: React.PropsWithChildren) => {
  // useEffect(() => {
  //   // Because the language is saved in the backend, a token is required to obtain the api. However, the login page cannot obtain the language through the getUserInfo api, so the language needs to be saved in localstorage.
  //   const lng = storage.getLanguage();
  //   if (lng) {
  //     i18n.changeLanguage(lng);
  //   }
  // }, []);

  return (
    <TooltipProvider>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider
          defaultTheme={ThemeEnum.Light}
          storageKey="ragflow-ui-theme"
        >
          <ReduxProvider store={store}>
            <Root>{children}</Root>
          </ReduxProvider>
        </ThemeProvider>
      </QueryClientProvider>
    </TooltipProvider>
  );
};
export function rootContainer(container: ReactNode) {
  return <RootProvider>{container}</RootProvider>;
}
